import { fetchPrivateApi, fetchPublicApi } from '@/lib/api/apiServiceBase.ts';
import { AdminInitiatePaymentRequest } from '@/features/dashboard/onlinePayments/types/AdminInitiatePaymentRequest.ts';

const onlinePaymentsApi = {
  // Admin endpoint
  initiate: async (
    dto: AdminInitiatePaymentRequest,
  ): Promise<{ id: string; paymentUrl: string }> => {
    return await fetchPrivateApi<{ id: string; paymentUrl: string }>(
      'POST',
      'online-payments/initiate',
      dto,
    );
  },

  // Public endpoint
  initiatePublicPayment: async (
    slug: string,
    request: {
      plannedTransactionId: string;
      provider: 'TPAY';
      successUrl: string;
      errorUrl: string;
    },
    token: string,
  ): Promise<{ id: string; paymentUrl: string }> => {
    return await fetchPublicApi<{ id: string; paymentUrl: string }>(
      'POST',
      `public/organizers/${slug}/payments/initiate?token=${token}`,
      request,
    );
  },
};

export default onlinePaymentsApi;
